import {
  formatDateRange,
  getDateRange,
} from '@modules/common/components/DateRangePicker/helpers';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { formatDateTimeRange } from '@modules/common/utils';

export function formatDashboardDateRange(timeRange: DateTimeRange): string {
  const [from, to] = getDateRange(timeRange);
  const dateRangeString = from && to ? formatDateRange(from, to) : '--';

  const formattedTimeRange = formatDateTimeRange(timeRange);

  switch (timeRange.type) {
    case 'last':
      return `${formattedTimeRange} (${dateRangeString})`;
    case 'since':
      return `${formattedTimeRange} (${dateRangeString})`;
    default:
      return formattedTimeRange;
  }
}
